import { compose } from 'recompose';
import withE2EProp from '../../withE2EProp';
import centeredQuestion from '../hoc/centeredQuestion';
import ShortTextQuestion from '../ShortTextQuestion';

export default compose(
  withE2EProp('respondent-custom-short-text'),
  centeredQuestion,
)(ShortTextQuestion);
